<template>
  <b-button @click="updateErpInfos()" :disabled="isLoading" variant>
    {{msg}}
    <i v-if="isLoading" class="fa fa-spinner fa-spin fa-fw"></i>
  </b-button>
</template>

<script>
import reference from '../../api/reference.vue'
import erpLoaderServer from '../../api/erp_loader_server.vue'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'UpdateInfoFromErp',
  data() {
    return {
      msg: "Recupérer les infos depuis l'ERP",
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      form: 'getFormKanban'
    })
  },
  methods: {
    updateErpInfos() {
      this.isLoading = true
      erpLoaderServer.getReferenceInfos(this.form.code, process.env.STORE).then(result => {
        const empl_erp = result.data.emplacement
        // update sage_emplacement AND pos x y z and zone
        this.form.pos_x = empl_erp[2] + empl_erp[3]
        this.form.pos_y = empl_erp[1]
        this.form.pos_z = empl_erp[4]
        this.form.zone = empl_erp[0]
        this.form.weight = result.data.weight
        this.form.customs = result.data.customs
        this.form.designation = result.data.designation
        this.isLoading = false
        this.makeToast("Référence mise à jour !")
      }).catch(() => {
          this.makeToast("Référence absente de l'ERP !")
          this.form.is_in_erp = false
      })
    }
  },
  mounted: function() {}
}
</script>


// WEBPACK FOOTER //
// src/components/kanban/UpdateInfoFromErp.vue